window.auguste = window.auguste || {};
window.auguste.SetLoginState = ( function()  {
    function set_state( state ) {
        if( state ) {
            localStorage.setItem( 'login_state' , 'true' );
        }
        else {
            localStorage.setItem( 'login_state' , 'false' );
        }
    }

    function init( logged_in = false ) {
        set_state( logged_in );
    }

    return {
        init
    };
}() );
